<script>
  import SideGroup from '/Groups/SideGroup'
  import CardMainContent from '/Widgets/CardMainContent'
  import Related from '/Groups/Related'
  import Body from '/Groups/Body'
  import Link from '/Atoms/Link'

  export let data

  let venue = data?.Venue || {}

  let infotext = venue?.infotext

  const title = venue?.title

  const externalLinks = venue?.externalLinks || []

  const parent_title = venue?.parentVenue?.[0]?.title
  const parent_slug = venue?.parentVenue?.[0]?.slug

  const sideWidgets = venue?.relatedWidgets || []

  const body = venue?.body || []

  // console.log(projectCollection, projectArtworks, projectProjects)

</script>

<div class="container">

  <section class="main">

    <CardMainContent
      category={parent_title}
      category_link={"../"+parent_slug}
      title={title}
    > 

    <span slot="headercontent">
      {venue?.strasseUndNummer} <br>
      {#if venue?.addreszusatz} {venue?.addreszusatz} <br> {/if}
      {venue?.plz} {venue?.stadt}
    </span>

      <Body {body} />

      <p class="externalLinks">
        {#each externalLinks as link}
          <span class="link">
            <Link markdown href={link.linkUrl}>{link.linkTitle}</Link>
          </span>
        {/each}
      </p>
    </CardMainContent>

    <Related data={venue} />

  </section>

  <aside class="side">
    <SideGroup widgets={sideWidgets} />
  </aside>

</div>

<style lang="scss">
  .container {
    @include grid-padding;
    @include media-2col {
      @include grid;
    }
  }

  .header {
    grid-column: 1 / span 9;
  }
  .main {
    grid-column: 1 / span 9;
    grid-row: 2;
  }

  .side {
    grid-column: 10 / span 3;
    grid-row: 2;
  }

  code {
    grid-row: 3;
    white-space: pre;
  }

  li, a {
    @include typo-grotesk-text-24;
  }

  .externalLinks {
    margin-top: 1em;
    .link {
      display: block;
    }
  }

</style>